import type {
  RefundCustomerFacingReadDTO,
  RefundReadDTO,
  RefundRequestedQueueReadDTO,
} from 'pi-kiosk-shared';

export type {
  RefundAttemptStatus,
  RefundCustomerFacingReadDTO,
  RefundCustomerStatus,
  RefundReadDTO,
  RefundRequestedQueueReadDTO,
  TransactionRefundProjectionStatus as TransactionRefundStatusProjection,
} from 'pi-kiosk-shared';

/** Additive order-detail / guest-lookup row (attempt or REQUESTED queue placeholder). */
export type { RefundCustomerFacingReadDTO as CustomerRefundReadDTO } from 'pi-kiosk-shared';

/**
 * Attempt row with optional confirmation PDF URL (backend customer/guest wire).
 * Intersects so tsc stays green against published `pi-kiosk-shared` until that
 * package includes `downloadUrl` on `RefundReadDTO`.
 */
export type RefundAttemptWithDownloadDTO = RefundReadDTO & {
  readonly downloadUrl?: string | null;
};

/** AC-24 queue placeholder — `attemptId` is `null` (never a string). */
export function isRefundRequestedQueueReadDTO(
  row: RefundCustomerFacingReadDTO,
): row is RefundRequestedQueueReadDTO {
  return row.attemptId === null;
}

export function isRefundAttemptWithDownloadDTO(
  row: RefundCustomerFacingReadDTO,
): row is RefundAttemptWithDownloadDTO {
  return row.attemptId !== null;
}

export function refundConfirmationDownloadUrl(
  refund: RefundAttemptWithDownloadDTO,
): string | null {
  const url = refund.downloadUrl;
  return typeof url === 'string' && url.trim().length > 0 ? url.trim() : null;
}
